//Web implementation of setupPushNotifications, currently not supported
export const setupPushNotifications = async () => {};
//Web implementation of subscribeNewReleasesPushNotifications, currently not supported
export const subscribeNewReleasesPushNotifications = async () => {};